import _ from 'lodash';
import * as actions from 'app/actions/support';

export default function(state = {}, action) {
  switch (action.type) {
    case actions.SET_SUPPORT_ARTICLE_DETAILS: {
      const newSlug = _.get(action.result, 'fields.slug');
      const newDeveloperId = `id-${_.get(action.result, 'fields.id')}`;
      return Object.assign({}, state, {
        loadedArticles: Object.assign({}, state.loadedArticles, {
          [newSlug]: action.result,
          [newDeveloperId]: action.result,
        }),
        selectedArticleSlug: newSlug,
      });
    }
    case actions.SET_SUPPORT_SELECTED_ARTICLE_SLUG: {
      return Object.assign({}, state, {
        selectedArticleSlug: action.slug,
      });
    }
    case actions.SET_REFERRAL_PAGE: {
      return Object.assign({}, state, {
        referralPage: _.get(action, 'result.fields'),
      });
    }
    case actions.SET_REFERRAL_INFO: {
      return Object.assign({}, state, {
        referralInfo: _.get(action, 'result'),
      });
    }
    case actions.PAYMENT_REQUEST_ATTEMPT: {
      return Object.assign({}, state, {
        status: _.get(action, 'result.status'),
      });
    }
    case actions.PAYPAL_REQUEST: {
      return Object.assign({}, state, {
        status: _.get(action, 'result.status'),
      });
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/support.js